export const setLocalStorageItem = (key: string, values: string) =>
  localStorage.setItem(key, values);
export const getLocalStorageItem = (key: string) => localStorage.getItem(key);
